/**
 * RUNNER design tokens for script and canvas use. Mirrors tokens.css; values come from the brand system
 * (brand/docs/BRAND_GUIDE.md, brand/docs/ART_DIRECTION.json). Keys are stable; derived shades are flat mixes of the
 * brand colours so the canvas world and the DOM stay one palette.
 */
export const color = {
  orange: '#EC673A',
  orangeDeep: '#9C341A',
  orangeSoft: '#F29169',
  cream: '#FFF2D8',
  paper: '#F5E9D4',
  paperDeep: '#D6C4A6',
  sand: '#D6C4A6',
  ink: '#0B0B0B',
  inkSoft: '#2A2723',
  muted: '#655D50',
  line: 'rgba(11,11,11,0.16)',
  harvest: '#73856A',
  harvestSoft: '#9DA68B',
  harvestDeep: '#4B5746',
  forge: '#9C341A',
  forgeSoft: '#F29169',
  ember: '#EC673A',
  soot: '#2A2723',
  water: '#76B5BF',
  waterSoft: '#9FC7C7',
  gold: '#EAAF43',
  goldSoft: '#F0C370',
  asphalt: '#74716A',
  road: '#D6C4A6',
  roadDark: '#BBA886',
  /** The character's body is near-black ink (BRAND_GUIDE "The chosen identity"), never a skin tone. */
  inkBody: '#0B0B0B',
  inkBodyShade: '#000000',
  inkBodyHi: '#2A2723',
  white: '#FFFAF0',
} as const;

export const font = {
  display: "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  mono: "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', monospace",
} as const;

/** UI durations in ms (brand: 120 / 180 / 320). */
export const motion = {
  quick: 120,
  base: 180,
  slow: 320,
} as const;
